import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
const CarHuddleInsuranceReviewRatingCard = ({reviewData = {}}) => {
    const {text = "", source = "", iconUrl = "", ratingText = ""} = reviewData || {};
    return (
        <div styleName={"styles.outer"}>
            <div styleName={"styles.excellentWrap"}>
                <p styleName={"excellentText"}>{ratingText}</p>
                <img src={iconUrl} />
            </div>
            <p styleName={"styles.review"}>{text}</p>
            <div styleName={"styles.trustpilot"}>
                <img src={source} />
            </div>
        </div>
    );
};

CarHuddleInsuranceReviewRatingCard.propTypes = {
    reviewData: PropTypes.object
};

export default CarHuddleInsuranceReviewRatingCard;
